<ng-template #rt let-r="result" let-t="term">
  {{ r.Name }}
</ng-template>
<ng-template #railairtemp let-r="result" let-t="term">
  {{ r.destination }}
</ng-template>

<app-flight-loading-screen [animated]="false"></app-flight-loading-screen>
@if (searchParams?.originalResultsNotFound | async) {
  <div class="light-error-box">
    <p i18n="@@flight_original_results_expired">
      This flight search result is no longer available. Please start a new search.
    </p>
    <a
      class="light-btn light-btn-primary"
      routerLink="/search"
      i18n="@@flight_original_results_start_new_search"
      >Start a new flight search</a
    >
  </div>
}
<div>
  @if (showSearchTabs && !(searchParams?.originalResultsNotFound | async)) {
    <app-flights-search-tabs> </app-flights-search-tabs>
  }
</div>
